// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoComp_wrapper__3qyGk","tooltip":"InfoComp_tooltip__NCdWY","icon":"InfoComp_icon__Mwegm","tooltipOverlay":"InfoComp_tooltipOverlay__UBKMZ"};